/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Namespace1Inputs */

const id_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ms_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const da_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const de_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const en_us2_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const es_es2_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const es_mx2_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const fil_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const fr_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const it_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const hu_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const nl_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const no_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const pl_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const pt_br2_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const pt_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ro_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const fi_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const sv_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const vi_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const tr_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const cs_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const bg_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ru_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пространство имён`)
};

const uk_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ar_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const hi_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नेमस्पेस`)
};

const th_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const ja_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

const zh_cn2_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命名空间`)
};

const zh_hant1_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命名空間`)
};

const ko_offerdetail_table_namespace1 = /** @type {(inputs: Offerdetail_Table_Namespace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namespace`)
};

/**
* | output |
* | --- |
* | "Namespace" |
*
* @param {Offerdetail_Table_Namespace1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_namespace1 = /** @type {((inputs?: Offerdetail_Table_Namespace1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Namespace1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_namespace1(inputs)
	if (locale === "ms") return ms_offerdetail_table_namespace1(inputs)
	if (locale === "da") return da_offerdetail_table_namespace1(inputs)
	if (locale === "de") return de_offerdetail_table_namespace1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_namespace1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_namespace1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_namespace1(inputs)
	if (locale === "fil") return fil_offerdetail_table_namespace1(inputs)
	if (locale === "fr") return fr_offerdetail_table_namespace1(inputs)
	if (locale === "it") return it_offerdetail_table_namespace1(inputs)
	if (locale === "hu") return hu_offerdetail_table_namespace1(inputs)
	if (locale === "nl") return nl_offerdetail_table_namespace1(inputs)
	if (locale === "no") return no_offerdetail_table_namespace1(inputs)
	if (locale === "pl") return pl_offerdetail_table_namespace1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_namespace1(inputs)
	if (locale === "pt") return pt_offerdetail_table_namespace1(inputs)
	if (locale === "ro") return ro_offerdetail_table_namespace1(inputs)
	if (locale === "fi") return fi_offerdetail_table_namespace1(inputs)
	if (locale === "sv") return sv_offerdetail_table_namespace1(inputs)
	if (locale === "vi") return vi_offerdetail_table_namespace1(inputs)
	if (locale === "tr") return tr_offerdetail_table_namespace1(inputs)
	if (locale === "cs") return cs_offerdetail_table_namespace1(inputs)
	if (locale === "bg") return bg_offerdetail_table_namespace1(inputs)
	if (locale === "ru") return ru_offerdetail_table_namespace1(inputs)
	if (locale === "uk") return uk_offerdetail_table_namespace1(inputs)
	if (locale === "ar") return ar_offerdetail_table_namespace1(inputs)
	if (locale === "hi") return hi_offerdetail_table_namespace1(inputs)
	if (locale === "th") return th_offerdetail_table_namespace1(inputs)
	if (locale === "ja") return ja_offerdetail_table_namespace1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_namespace1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_namespace1(inputs)
	return ko_offerdetail_table_namespace1(inputs)
});
export { offerdetail_table_namespace1 as "offerDetail.table.namespace" }